import { getShowMailAnnouncement } from '../utils/index';

import { localStore } from './storage';
import { dateDiff } from './utils';

interface AnnouncementState {
    updateAt: string | Date;
    isVisible: boolean;
}

const getAnnouncmentData = () => localStore.get<AnnouncementState>(localStore.keys.announcement);

const setAnnouncmentVible = (value: boolean, updateAt: Date = new Date()) =>
    localStore.set<AnnouncementState>(localStore.keys.announcement, { updateAt, isVisible: value });

export const updateAnnouncementState = () => {
    const storageInfo = getAnnouncmentData();
    setAnnouncmentVible(storageInfo ? !storageInfo.isVisible : true);
};

export const shouldShowAnnouncement = () => {
    const { hasNewsSubscription } = __appConfig.user;
    const { displayAnnouncement } = __appConfig.app;
    if (!hasNewsSubscription && displayAnnouncement && getShowMailAnnouncement()) {
        const storageInfo = getAnnouncmentData();
        if (storageInfo) {
            const { updateAt, isVisible } = storageInfo;
            const updateAtDate = new Date(updateAt);

            isVisible && setAnnouncmentVible(false, updateAtDate);
            return dateDiff(new Date(), updateAtDate, 'Day') > __appConfig.app.announcementIntervalDays;
        }
        return true;
    }
    return false;
};
